/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section2_Li4Inputs */

const en_about_section2_li4 = /** @type {(inputs: About_Section2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-Language: Available in English, Korean, and Japanese with full localization support.`)
};

const ko_about_section2_li4 = /** @type {(inputs: About_Section2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다국어 지원: 영어, 한국어, 일본어로 완전한 현지화를 지원합니다.`)
};

const ja_about_section2_li4 = /** @type {(inputs: About_Section2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多言語対応：英語、韓国語、日本語の完全なローカライゼーションをサポートしています。`)
};

/**
* | output |
* | --- |
* | "Multi-Language: Available in English, Korean, and Japanese with full localization support." |
*
* @param {About_Section2_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section2_li4 = /** @type {((inputs?: About_Section2_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section2_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section2_li4(inputs)
	if (locale === "ko") return ko_about_section2_li4(inputs)
	return ja_about_section2_li4(inputs)
});